import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 11h.009","key":"svg-0"}],["path",{"d":"M14 15h.009","key":"svg-1"}],["path",{"d":"M12 6h.009","key":"svg-2"}],["path",{"d":"M8 10h.009","key":"svg-3"}],["path",{"d":"M3 21l17 -17","key":"svg-4"}],["path",{"d":"M3 3v18h18","key":"svg-5"}]]

const IconChartCovariate = createReactComponent('outline', 'chart-covariate', 'ChartCovariate', __iconNode);

export default IconChartCovariate;